/* @flow */
import userAgent from 'lib/currentUserAgent';
import type { RouterState, LocationDescriptor } from 'lib/ReactRouterTypes';

export default function requireDesktopOnEnter(
  nextState: RouterState,
  replaceWith: (location: LocationDescriptor) => void
) {
  const { query, pathname } = nextState.location;

  const deviceOkay = userAgent.isDesktop() || (userAgent.tablet() && userAgent.ie());

  if (!deviceOkay) {
    query.path = pathname;
    replaceWith({ pathname: '/get_the_app', query });
  }
}
